var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 8983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M13.3 15.0218C12.2 14.6881 12 14.0541 12 13.687V13.0196C12.6621 12.3875 13.1255 11.5756 13.3333 10.6836C14.1667 10.6836 14.6667 9.68253 14.6667 8.6814C14.6667 8.41444 14.6667 7.34657 14 7.34657C15.6667 2.50782 10.8 0.672425 7.33334 3.00838C5.86667 3.00838 5.46667 5.21085 6 7.34657C5.33334 7.34657 5.33334 8.41444 5.33334 8.6814C5.33334 9.68253 5.83334 10.6836 6.66667 10.6836C6.87635 11.5749 7.33946 12.3863 8.00001 13.0196V13.687C8.00001 14.2209 7.83334 14.8884 5.13334 15.4223C2.43333 15.9562 2 18.3589 2 18.3589H12.7667",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M19.3332 16.0229L16.9998 18.6926L15.6665 17.3578",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1_2",
    d: "M17.3332 22.0296C19.9105 22.0296 21.9998 19.9379 21.9998 17.3577C21.9998 14.7775 19.9105 12.6858 17.3332 12.6858C14.7558 12.6858 12.6665 14.7775 12.6665 17.3577C12.6665 19.9379 14.7558 22.0296 17.3332 22.0296Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.8d5a0229259e1ecf5302cad5d32b6fd0.svg";
export { ForwardRef as ReactComponent };